import axios from 'axios';

const DISTRIBUTOR_APP_DISABLED = 'DISTRIBUTOR_APP_DISABLED';

let redirecting = false;

// Full logout, then the login page shows the "Application Temporarily Unavailable" screen
function logoutToUnavailable() {
    if (redirecting) return;
    redirecting = true;
    localStorage.clear();
    window.location.replace('/');
}

/**
 * App status is only checked on the login page. After login, the backend blocks
 * create / update / delete APIs with a 403 DISTRIBUTOR_APP_DISABLED when the
 * application is disabled, and this logs the distributor out.
 */
export function setupAppAccessInterceptor() {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 403 && error.response?.data?.error_code === DISTRIBUTOR_APP_DISABLED) {
                logoutToUnavailable();
            }
            return Promise.reject(error);
        },
    );
}
